import { useState, useEffect } from 'react';
import { useCollection } from './useCollection';
import { useSelector, useDispatch } from 'react-redux';
import { setUserProgram } from '../context/userProgramSlice';


export const useCreateUserProgramTreeData = () => {
    const [myArray, setArray] = useState([]);
    const emailId = useSelector((state) => state.user.emailId)
    const { data: userPrograms } = useCollection(`/VimeoPrograms/${emailId}`)
   
    const dispatch = useDispatch()
    dispatch(setUserProgram(userPrograms))
 
    useEffect(() => {
        const updateArray = (id, parent, droppable, text, idx) => {
            const newItem = {
                id: id,
                parent: parent,
                droppable: droppable,
                text: text,
                data: {
                    idx: idx
                }
            };
            setArray(prevArray => [...prevArray, newItem]);
        };

        let folders = userPrograms && userPrograms.map(program => (
            program.splitCategory
        ))

        const uniqueFolders = []
        folders && folders.map(folder => {
            if (uniqueFolders.indexOf(folder) === -1) {
                uniqueFolders.push(folder)
            }
            return null
        });

        if (!userPrograms || userPrograms.length === 0) {
            // give it a unique and identifiable id to handle specially in the tree
            updateArray(1969, 0, true, "Dra og slipp programmer her...", 0)
        }

        uniqueFolders && uniqueFolders.map(folder => {
            updateArray(folder, 0, true, folder, 0)
            userPrograms && userPrograms.filter(p => p.splitCategory === folder).map(prog => {
                updateArray(prog.id, folder, false, prog.name, prog.idx)
                return null
            })
            return null
        })

        // Clean up function
        return () => {
            setArray([]); // Reset the array when the component unmounts
        };
    }, [userPrograms]);

    return { myArray, setArray };
};
